export const normalizeDirectConsultationImages = (fileList) => {
    return (Array.isArray(fileList) ? fileList : []).map((file, index) => ({
        manual_id: file.manual_id || file.uid || file.id || `direct-consultation-image-${index}`,
        src: file.originalImage || file.src || file.url
    })).filter(image => image.src);
};
